import React from "react";
import conf from "./../../config.js";
import axios from "axios";

export default class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      mobileMenuOpen: false,
      currentNewsIndex: 0,
      newsList: [
        {
          id: "1",
          title: "Bencana Kabut Asap Ganggu Sektor Penerbangan, Kemenhub Tegaskan Regulasi Keselamatan Airway",
          image: "https://s3.schoolmedia.id/05-news-sm/uploads/konten/6acc9f84140760.webp",
          type: "berita",
          time: "16:00 WIB",
          url: "https://news.schoolmedia.id",
        },
        {
          id: "2",
          title: "Polisi Tetapkan Dua Anak dalam Kasus Dugaan Perundungan Siswa SD di Pemalang",
          image: "https://s3.schoolmedia.id/05-news-sm/uploads/konten/6ac8b748750060.webp",
          type: "berita",
          time: "14:30 WIB",
          url: "https://news.schoolmedia.id",
        },
        {
          id: "3",
          title: "Polri dan BNN Gelar Operasi Pemberantasan Narkoba di Kampung Ambon dan Kampung Boncos",
          image: "https://s3.schoolmedia.id/05-news-sm/uploads/konten/6ac8b5c6411a60.webp",
          type: "berita",
          time: "11:15 WIB",
          url: "https://news.schoolmedia.id",
        },
        {
          id: "4",
          title: "Mendikdasmen Dorong Penguatan Karakter dan Literasi Digital di Seluruh Satuan Pendidikan",
          image: "https://s3.schoolmedia.id/05-news-sm/uploads/konten/6acc9f84140760.webp",
          type: "berita",
          time: "09:00 WIB",
          url: "https://news.schoolmedia.id",
        },
      ],
    };

    this.autoTimer = null;
    this.login = this.login.bind(this);
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.nextNews = this.nextNews.bind(this);
    this.prevNews = this.prevNews.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.fetchLatestNews = this.fetchLatestNews.bind(this);
  }

  componentDidMount() {
    // Pastikan styling root & body match latar belakang gelap #001a33
    const rootEl = document.getElementById("root");
    if (rootEl) {
      rootEl.style.minWidth = "0";
      rootEl.style.width = "100%";
      rootEl.style.backgroundColor = "#001a33";
    }
    if (document.body) {
      document.body.style.backgroundColor = "#001a33";
    }

    // Cek session login user
    const token = localStorage.getItem("token");
    if (token && token.trim() !== "") {
      window.location.replace("/profil");
    }

    // Ambil berita terbaru secara dinamis dari API backend
    this.fetchLatestNews();

    // Mulai auto-slider
    this.startTimer();
  }

  fetchLatestNews() {
    axios
      .get(`${conf.uri_backend}api/publik/v1/news/latest?limit=6`)
      .then((res) => {
        const newsData = res.data && res.data.data ? res.data.data : res.data;
        if (Array.isArray(newsData) && newsData.length > 0) {
          this.setState({ newsList: newsData });
        }
      })
      .catch((err) => {
        // Jika backend offline atau belum siap, tetap gunakan default newsList
        console.log("Menggunakan fallback berita:", err.message);
      });
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer() {
    this.stopTimer();
    this.autoTimer = setInterval(this.nextNews, 5500);
  }

  stopTimer() {
    if (this.autoTimer) {
      clearInterval(this.autoTimer);
      this.autoTimer = null;
    }
  }

  resetTimer() {
    this.stopTimer();
    this.startTimer();
  }

  nextNews() {
    this.setState((prevState) => ({
      currentNewsIndex:
        (prevState.currentNewsIndex + 1) % prevState.newsList.length,
    }));
  }

  prevNews() {
    this.setState((prevState) => ({
      currentNewsIndex:
        (prevState.currentNewsIndex - 1 + prevState.newsList.length) %
        prevState.newsList.length,
    }));
  }

  toggleMobileMenu() {
    this.setState((prevState) => ({
      mobileMenuOpen: !prevState.mobileMenuOpen,
    }));
  }

  login() {
    this.setState({ loading: true });
    localStorage.setItem("alert", "");
    axios
      .get(`${conf.uri_backend}api/v1/auth/client`)
      .then((res) => {
        const clientData =
          typeof res.data.data === "string"
            ? JSON.parse(res.data.data)
            : res.data.data;

        window.location.replace(
          `${conf.uri_sso}auth/is_login?client_id=${clientData.client_id}&redirect_uri=${clientData.caught_uri}`
        );
      })
      .catch((err) => {
        console.error("Gagal terhubung ke backend auth client:", err);
        this.setState({ loading: false });
        alert(
          `Gagal terhubung ke backend API (${conf.uri_backend}). Periksa apakah backend berjalan dan URL backend sesuai.`
        );
      });
  }

  render() {
    const { loading, mobileMenuOpen, currentNewsIndex, newsList } = this.state;
    const alertMsg = localStorage.getItem("alert");

    return (
      <div className="landing-page-wrapper">
        <style
          dangerouslySetInnerHTML={{
            __html: `
            @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Instrument+Sans:wght@400;500;600;700&display=swap');

            .sm-navbar, .footer-container, footer {
              display: none !important;
            }

            #root {
              min-width: 0 !important;
              width: 100% !important;
              overflow-x: hidden !important;
              background-color: #001a33 !important;
            }
            body, html {
              margin: 0 !important;
              padding: 0 !important;
              width: 100% !important;
              min-height: 100% !important;
              background-color: #001a33 !important;
              font-family: 'Plus Jakarta Sans', 'Instrument Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
              overflow-x: hidden !important;
              color: #ffffff;
            }

            .landing-page-wrapper {
              min-height: 100vh;
              width: 100%;
              background-color: #001a33;
              color: #ffffff;
              display: flex;
              flex-direction: column;
              position: relative;
              overflow-x: hidden;
            }

            /* 1. Navbar Header: Solid #001a33 */
            .lp-navbar-header {
              width: 100%;
              background-color: #001a33;
              position: relative;
              z-index: 50;
            }
            .lp-navbar-inner {
              max-width: 1260px;
              margin: 0 auto;
              padding: 1.15rem 2rem 0.85rem 2rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            .lp-logo-wrap {
              display: flex;
              align-items: center;
              text-decoration: none;
            }
            .lp-logo-img {
              height: 42px;
              width: auto;
              object-fit: contain;
              user-select: none;
            }
            .lp-nav-menu {
              display: flex;
              align-items: center;
              gap: 2rem;
              list-style: none;
              margin: 0;
              padding: 0;
            }
            .lp-nav-item a {
              color: #ffffff;
              text-decoration: none;
              font-size: 0.95rem;
              font-weight: 500;
              transition: color 0.2s ease;
            }
            .lp-nav-item a:hover {
              color: #db8a32;
            }
            .lp-mobile-toggle {
              display: none;
              background: none;
              border: none;
              color: white;
              cursor: pointer;
              padding: 0.5rem;
            }
            .lp-mobile-menu {
              display: none;
              flex-direction: column;
              gap: 0.75rem;
              background: rgba(0, 26, 51, 0.98);
              backdrop-filter: blur(10px);
              padding: 1.25rem 2rem;
              border-bottom: 1px solid rgba(255, 255, 255, 0.08);
            }
            .lp-mobile-menu.active {
              display: flex;
            }
            .lp-mobile-menu a {
              color: white;
              text-decoration: none;
              font-size: 0.95rem;
              font-weight: 500;
              padding: 0.4rem 0;
              border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            }

            /* 2. Hero Section: Background image starts here */
            .lp-hero-section {
              width: 100%;
              flex: 1;
              background-color: #001a33;
              background-image: url("/assets/img/bg-register-2.jpg");
              background-size: cover;
              background-position: center top;
              background-repeat: no-repeat;
              display: flex;
              align-items: center;
            }
            .lp-hero-inner {
              max-width: 1260px;
              width: 100%;
              margin: 0 auto;
              padding: 1.5rem 2rem 2.5rem 2rem;
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 3.5rem;
            }

            /* Left Column */
            .lp-hero-left {
              flex: 1;
              max-width: 530px;
            }
            .lp-hero-title {
              font-size: 3.25rem;
              font-weight: 800;
              line-height: 1.15;
              letter-spacing: -0.02em;
              color: #ffffff;
              margin-bottom: 1.2rem;
            }
            .lp-hero-title .highlight {
              color: #db8a32;
            }
            .lp-hero-description {
              font-size: 0.925rem;
              line-height: 1.75;
              color: #e2e8f0;
              margin-bottom: 2rem;
              text-align: left;
              font-weight: 400;
            }
            .lp-btn-masuk {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              background-color: #db8a32;
              color: #ffffff;
              font-size: 1rem;
              font-weight: 700;
              padding: 0.8rem 2.85rem;
              border-radius: 9999px;
              text-decoration: none;
              transition: all 0.25s ease;
              box-shadow: 0 8px 20px -3px rgba(219, 138, 50, 0.45);
              border: none;
              cursor: pointer;
              outline: none;
            }
            .lp-btn-masuk:hover:not(:disabled) {
              background-color: #c57622;
              transform: translateY(-2px);
              box-shadow: 0 12px 25px -4px rgba(219, 138, 50, 0.55);
            }
            .lp-btn-masuk:disabled {
              opacity: 0.75;
              cursor: not-allowed;
            }

            /* Right Column: Kabar Terkini (Top) + Bursa Konten (Bottom) */
            .lp-hero-right {
              flex: 1;
              max-width: 540px;
              display: flex;
              flex-direction: column;
              gap: 1.25rem;
            }

            /* Section Headers */
            .lp-section-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 0.55rem;
            }
            .lp-section-title {
              display: flex;
              align-items: center;
              gap: 0.45rem;
              font-size: 0.825rem;
              font-weight: 800;
              color: #ffffff;
              letter-spacing: 0.05em;
              text-transform: uppercase;
            }
            .lp-section-title svg {
              color: #db8a32;
            }
            .lp-slider-controls {
              display: flex;
              align-items: center;
              gap: 0.35rem;
            }
            .lp-slider-btn {
              width: 30px;
              height: 30px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.12);
              border: 1px solid rgba(255, 255, 255, 0.2);
              color: #ffffff;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              transition: all 0.2s ease;
              backdrop-filter: blur(6px);
              outline: none;
              padding: 0;
            }
            .lp-slider-btn:hover {
              background: #db8a32;
              border-color: #db8a32;
              transform: scale(1.05);
            }

            /* 1. News Card Horizontal Slider */
            .lp-news-slider-wrapper {
              position: relative;
              width: 100%;
              height: 155px;
            }
            .lp-news-card-item {
              position: absolute;
              inset: 0;
              background: #ffffff;
              border-radius: 18px;
              overflow: hidden;
              display: flex;
              box-shadow: 0 16px 30px -5px rgba(0, 0, 0, 0.4);
              opacity: 0;
              visibility: hidden;
              transform: scale(0.97);
              transition: all 0.35s cubic-bezier(0.25, 1, 0.5, 1);
              text-decoration: none;
              cursor: pointer;
            }
            .lp-news-card-item.active {
              opacity: 1;
              visibility: visible;
              transform: scale(1);
            }
            .lp-news-img-col {
              width: 42%;
              position: relative;
              background: #0b1a3d;
              overflow: hidden;
              flex-shrink: 0;
            }
            .lp-news-img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;
            }
            .lp-news-card-item:hover .lp-news-img {
              transform: scale(1.05);
            }
            .lp-news-content-col {
              width: 58%;
              padding: 0.95rem 1.15rem 0.9rem 1.15rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              background: #ffffff;
            }
            .lp-news-badge {
              align-self: flex-start;
              background: #0b1a3d;
              color: #ffffff;
              font-size: 0.625rem;
              font-weight: 800;
              padding: 0.18rem 0.55rem;
              border-radius: 9999px;
              text-transform: uppercase;
              letter-spacing: 0.04em;
              margin-bottom: 0.35rem;
              display: inline-block;
            }
            .lp-news-title {
              font-size: 0.875rem;
              font-weight: 700;
              color: #0f172a;
              line-height: 1.35;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              transition: color 0.2s ease;
              margin: 0;
            }
            .lp-news-card-item:hover .lp-news-title {
              color: #db8a32;
            }
            .lp-news-footer {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding-top: 0.5rem;
              border-top: 1px solid #f1f5f9;
            }
            .lp-news-meta {
              font-size: 0.68rem;
              color: #64748b;
            }
            .lp-news-read-more {
              display: inline-flex;
              align-items: center;
              gap: 0.25rem;
              font-size: 0.775rem;
              font-weight: 700;
              color: #162fc9;
              transition: gap 0.2s ease, color 0.2s ease;
            }
            .lp-news-card-item:hover .lp-news-read-more {
              gap: 0.45rem;
              color: #db8a32;
            }

            /* 2. Bursa Konten 2x2 Grid */
            .lp-bursa-grid {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 0.85rem;
              width: 100%;
            }
            .lp-bursa-card {
              background: #ffffff;
              border-radius: 16px;
              padding: 0.95rem 1.05rem;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              text-decoration: none;
              box-shadow: 0 10px 22px -3px rgba(0, 0, 0, 0.25);
              transition: all 0.25s ease;
              cursor: pointer;
              height: 110px;
            }
            .lp-bursa-card:hover {
              transform: translateY(-3px);
              box-shadow: 0 16px 28px -3px rgba(0, 0, 0, 0.35);
            }
            .lp-bursa-card-top {
              display: flex;
              align-items: center;
              gap: 0.65rem;
            }
            .lp-bursa-icon-circle {
              width: 38px;
              height: 38px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #ffffff;
              flex-shrink: 0;
              box-shadow: 0 3px 8px rgba(0, 0, 0, 0.15);
            }
            .lp-bursa-card-info {
              display: flex;
              flex-direction: column;
            }
            .lp-bursa-card-title {
              font-size: 0.925rem;
              font-weight: 700;
              color: #0f172a;
              line-height: 1.2;
              margin: 0;
            }
            .lp-bursa-card-subtitle {
              font-size: 0.72rem;
              color: #64748b;
              margin-top: 0.15rem;
            }
            .lp-bursa-card-action {
              display: flex;
              align-items: center;
              gap: 0.3rem;
              font-size: 0.75rem;
              font-weight: 700;
              color: #162fc9;
              transition: gap 0.2s ease, color 0.2s ease;
              margin-top: 0.5rem;
            }
            .lp-bursa-card:hover .lp-bursa-card-action {
              color: #db8a32;
              gap: 0.45rem;
            }

            /* Responsive Breakpoints */
            @media (max-width: 1024px) {
              .lp-hero-inner {
                flex-direction: column;
                gap: 2.5rem;
                padding: 1.5rem 2rem;
              }
              .lp-hero-left {
                max-width: 100%;
                text-align: center;
              }
              .lp-hero-description {
                text-align: center;
              }
              .lp-hero-right {
                max-width: 100%;
                width: 100%;
              }
            }
            @media (max-width: 768px) {
              .lp-nav-menu {
                display: none;
              }
              .lp-mobile-toggle {
                display: block;
              }
              .lp-hero-title {
                font-size: 2.6rem;
              }
              .lp-news-slider-wrapper {
                height: auto;
                min-height: 140px;
              }
              .lp-news-card-item {
                position: relative;
                flex-direction: row;
              }
            }
            @media (max-width: 540px) {
              .lp-navbar-inner {
                padding: 1rem 1.25rem 0.5rem 1.25rem;
              }
              .lp-hero-inner {
                padding: 1rem 1.25rem 2rem 1.25rem;
              }
              .lp-hero-title {
                font-size: 2.15rem;
              }
              .lp-news-card-item {
                flex-direction: column;
              }
              .lp-news-img-col {
                width: 100%;
                height: 130px;
              }
              .lp-news-content-col {
                width: 100%;
              }
              .lp-bursa-grid {
                grid-template-columns: 1fr;
              }
              .lp-bursa-card {
                height: auto;
              }
            }
          `,
          }}
        />

        {/* 1. Navbar Header */}
        <header className="lp-navbar-header">
          <div className="lp-navbar-inner">
            <a href="/" className="lp-logo-wrap">
              <img
                src="/assets/img/schoolmedia-um-logo-white.png"
                alt="Schoolmedia UM"
                className="lp-logo-img"
                onError={(e) => {
                  e.target.src = "/schoolmedia-um-logo-white.png";
                }}
              />
            </a>
            <nav>
              <ul className="lp-nav-menu">
                <li className="lp-nav-item">
                  <a
                    href="https://about.schoolmedia.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Tentang
                  </a>
                </li>
                <li className="lp-nav-item">
                  <a
                    href="https://schoolmedia.co.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Layanan
                  </a>
                </li>
                <li className="lp-nav-item">
                  <a
                    href="https://sbiz.co.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sbiz
                  </a>
                </li>
                <li className="lp-nav-item">
                  <a
                    href="https://schoolmedia.co.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Kebijakan Privasi
                  </a>
                </li>
                <li className="lp-nav-item">
                  <a
                    href="https://schoolmedia.co.id"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Syarat & Ketentuan
                  </a>
                </li>
              </ul>
              <button
                className="lp-mobile-toggle"
                onClick={this.toggleMobileMenu}
                aria-label="Toggle Menu"
              >
                <svg
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </nav>
          </div>
        </header>

        {/* Mobile Dropdown Menu */}
        <div className={`lp-mobile-menu ${mobileMenuOpen ? "active" : ""}`}>
          <a
            href="https://about.schoolmedia.id"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tentang
          </a>
          <a
            href="https://schoolmedia.co.id"
            target="_blank"
            rel="noopener noreferrer"
          >
            Layanan
          </a>
          <a
            href="https://sbiz.co.id/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sbiz
          </a>
          <a
            href="https://schoolmedia.co.id"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kebijakan Privasi
          </a>
          <a
            href="https://schoolmedia.co.id"
            target="_blank"
            rel="noopener noreferrer"
          >
            Syarat & Ketentuan
          </a>
        </div>

        {/* 2. Hero Section */}
        <main className="lp-hero-section">
          <div className="lp-hero-inner">
            {/* Left Hero Column */}
            <div className="lp-hero-left">
              {alertMsg && alertMsg !== "" && (
                <div
                  style={{
                    backgroundColor: "rgba(245, 158, 11, 0.15)",
                    borderLeft: "4px solid #f59e0b",
                    color: "#fef3c7",
                    padding: "0.75rem 1rem",
                    marginBottom: "1.25rem",
                    borderRadius: "0.25rem",
                  }}
                  role="alert"
                >
                  <p style={{ fontWeight: 600, fontSize: "0.875rem", margin: 0 }}>
                    Informasi
                  </p>
                  <p style={{ fontSize: "0.85rem", marginTop: "0.25rem", margin: 0 }}>
                    {alertMsg}
                  </p>
                </div>
              )}

              <h1 className="lp-hero-title">
                User <span className="highlight">Management</span>
              </h1>
              <p className="lp-hero-description">
                UM Schoolmedia adalah aplikasi manajemen pengguna sekolah
                (siswa, guru, orang tua, dan lainnya) yang mencakup pembuatan
                akun, penugasan pendidik, pembentukan rombel, penyusunan jadwal
                pelajaran, serta penyedia data pendukung CMS dan Single Sign-On
                (SSO) terpusat.
              </p>
              <button
                id="btn-masuk-landing"
                onClick={this.login}
                disabled={loading}
                className="lp-btn-masuk"
              >
                {loading ? (
                  <span style={{ display: "inline-flex", alignItems: "center" }}>
                    <svg
                      style={{
                        width: "18px",
                        height: "18px",
                        marginRight: "8px",
                        animation: "spin 1s linear infinite",
                      }}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                    >
                      <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        style={{ opacity: 0.25 }}
                      />
                      <path
                        fill="currentColor"
                        style={{ opacity: 0.75 }}
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                    Tunggu...
                  </span>
                ) : (
                  "Masuk"
                )}
              </button>
            </div>

            {/* Right Hero Column: Kabar Terkini + Bursa Konten */}
            <div className="lp-hero-right">
              {/* Part A: Kabar Terkini */}
              <div className="lp-kabar-terkini-wrap">
                <div className="lp-section-header">
                  <div className="lp-section-title">
                    <svg
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 7.5h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.504 1.125 1.125V18a2.25 2.25 0 01-2.25 2.25M16.5 7.5V18a2.25 2.25 0 002.25 2.25M16.5 7.5V4.875c0-.621-.504-1.125-1.125-1.125H4.125C3.504 3.75 3 4.254 3 4.875V18a2.25 2.25 0 002.25 2.25h13.5"
                      />
                    </svg>
                    <span>Kabar Terkini</span>
                  </div>
                  <div className="lp-slider-controls">
                    <button
                      className="lp-slider-btn"
                      onClick={() => {
                        this.prevNews();
                        this.resetTimer();
                      }}
                      aria-label="Sebelumnya"
                    >
                      <svg
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15.75 19.5L8.25 12l7.5-7.5"
                        />
                      </svg>
                    </button>
                    <button
                      className="lp-slider-btn"
                      onClick={() => {
                        this.nextNews();
                        this.resetTimer();
                      }}
                      aria-label="Berikutnya"
                    >
                      <svg
                        width="14"
                        height="14"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M8.25 4.5l7.5 7.5-7.5 7.5"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                {/* News Slider Container */}
                <div
                  className="lp-news-slider-wrapper"
                  onMouseEnter={this.stopTimer}
                  onMouseLeave={this.startTimer}
                >
                  {newsList.map((item, index) => {
                    const isActive = index === currentNewsIndex;
                    return (
                      <a
                        key={item.id}
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`lp-news-card-item ${isActive ? "active" : ""}`}
                      >
                        <div className="lp-news-img-col">
                          <img
                            src={item.image}
                            alt={item.title}
                            className="lp-news-img"
                            onError={(e) => {
                              e.target.src = "/assets/img/landing_page_bg.png";
                            }}
                          />
                        </div>
                        <div className="lp-news-content-col">
                          <div>
                            <span className="lp-news-badge">Berita</span>
                            <h3 className="lp-news-title" title={item.title}>
                              {item.title}
                            </h3>
                          </div>
                          <div className="lp-news-footer">
                            <span className="lp-news-meta">
                              Schoolmedia News • {item.time}
                            </span>
                            <span className="lp-news-read-more">
                              <span>Baca Berita</span>
                              <svg
                                width="12"
                                height="12"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>

              {/* Part B: Bursa Konten 2x2 Grid */}
              <div className="lp-bursa-konten-wrap">
                <div className="lp-section-header">
                  <div className="lp-section-title">
                    <svg
                      width="16"
                      height="16"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
                      />
                    </svg>
                    <span>Bursa Konten</span>
                  </div>
                </div>

                <div className="lp-bursa-grid">
                  {/* Card 1: Film */}
                  <a
                    href="https://film.schoolmedia.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-bursa-card"
                  >
                    <div className="lp-bursa-card-top">
                      <div
                        className="lp-bursa-icon-circle"
                        style={{ backgroundColor: "#ea580c" }}
                      >
                        <svg
                          width="18"
                          height="18"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm6 4v8l6-4-6-4z" />
                        </svg>
                      </div>
                      <div className="lp-bursa-card-info">
                        <h4 className="lp-bursa-card-title">Film</h4>
                        <span className="lp-bursa-card-subtitle">
                          Tayangan edukatif
                        </span>
                      </div>
                    </div>
                    <div className="lp-bursa-card-action">
                      <span>Lihat konten</span>
                      <svg
                        width="13"
                        height="13"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </div>
                  </a>

                  {/* Card 2: Bahan Ajar */}
                  <a
                    href="https://bahanajar.schoolmedia.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-bursa-card"
                  >
                    <div className="lp-bursa-card-top">
                      <div
                        className="lp-bursa-icon-circle"
                        style={{ backgroundColor: "#1d4ed8" }}
                      >
                        <svg
                          width="18"
                          height="18"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
                          />
                        </svg>
                      </div>
                      <div className="lp-bursa-card-info">
                        <h4 className="lp-bursa-card-title">Bahan Ajar</h4>
                        <span className="lp-bursa-card-subtitle">
                          Materi belajar
                        </span>
                      </div>
                    </div>
                    <div className="lp-bursa-card-action">
                      <span>Lihat konten</span>
                      <svg
                        width="13"
                        height="13"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </div>
                  </a>

                  {/* Card 3: Event */}
                  <a
                    href="https://event.schoolmedia.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-bursa-card"
                  >
                    <div className="lp-bursa-card-top">
                      <div
                        className="lp-bursa-icon-circle"
                        style={{ backgroundColor: "#10b981" }}
                      >
                        <svg
                          width="18"
                          height="18"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5"
                          />
                        </svg>
                      </div>
                      <div className="lp-bursa-card-info">
                        <h4 className="lp-bursa-card-title">Event</h4>
                        <span className="lp-bursa-card-subtitle">
                          Agenda kegiatan
                        </span>
                      </div>
                    </div>
                    <div className="lp-bursa-card-action">
                      <span>Lihat konten</span>
                      <svg
                        width="13"
                        height="13"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </div>
                  </a>

                  {/* Card 4: Kuis */}
                  <a
                    href="https://kuisioner.schoolmedia.id/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="lp-bursa-card"
                  >
                    <div className="lp-bursa-card-top">
                      <div
                        className="lp-bursa-icon-circle"
                        style={{ backgroundColor: "#8b5cf6" }}
                      >
                        <svg
                          width="18"
                          height="18"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M12 18h.008v.008H12V18z"
                          />
                        </svg>
                      </div>
                      <div className="lp-bursa-card-info">
                        <h4 className="lp-bursa-card-title">Kuis</h4>
                        <span className="lp-bursa-card-subtitle">
                          Uji pemahaman
                        </span>
                      </div>
                    </div>
                    <div className="lp-bursa-card-action">
                      <span>Lihat konten</span>
                      <svg
                        width="13"
                        height="13"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                        />
                      </svg>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
